// Слоты расписания в контракте лежат числами (часы/минуты), а input[type=time]
// работает со строкой "ЧЧ:ММ" — конвертация между этими представлениями.

const pad = (value: number) => String(value).padStart(2, "0");

export const toTimeString = (hour: number, minute: number): string =>
    `${pad(hour)}:${pad(minute)}`;

export interface ParsedTime {
    hour: number;
    minute: number;
}

// Пустая строка приходит, когда пользователь очистил поле — время не меняем.
export const parseTimeString = (value: string): ParsedTime | null => {
    const match = /^(\d{1,2}):(\d{2})$/.exec(value);
    if (!match) return null;

    const hour = Number(match[1]);
    const minute = Number(match[2]);

    if (hour > 23 || minute > 59) return null;

    return { hour, minute };
};
